<template>
    <div class="sidenav" :class="{ moveDownVisible, moveUpVisible }" @scroll.passive="sidenavScroll">

        <div class="move-up" @click="scrollUp">
            <img :src="$imageUrl('arrow_up.svg')" alt="▲" width="15">
        </div>

        <ol class="sidenav-list">
            <SideNavItem v-for="(product, id, index) in products" :key="product.id" @click="goToStep(index)" :item="{
				id: product.id,
				label: product.name,
				icon: product.image,
				active: activeIndex === index,
				finished: typeof $db.products[id] !== 'undefined' || (id === 'contrasts' && (typeof $db.products['contrasts-cuff'] !== 'undefined' || typeof $db.products['contrasts-collar'] !== 'undefined'))
			}"/>

            <SideNavItem @click="goToStep(Object.keys(products).length)" :item="{
				id: 'measurements',
				label: $tr.measurements.input.title,
				icon: $imageUrl('products/_icons/mereni.svg'),
				active: activeIndex >= Object.keys(products).length,
				finished: false
			}"/>
        </ol>

        <div class="move-down" @click="scrollDown">
            <img :src="$imageUrl('arrow_down.svg')" alt="▼" width="15">
        </div>

        <div v-if="false">
            Sidenav to jump between steps.
            Multiple instances of - SideNavItem
        </div>
    </div>
</template>

<script>
import SideNavItem from "./SideNav/SideNavItem";

export default {
    name: "SideNav",
    components: {
        SideNavItem,
    },
    props: [
        "products",
        "activeIndex"
    ],
    data() {
        return {
            moveUpVisible: false,
            moveDownVisible: false,
        };
    },
    methods: {
        goToStep(step) {
            this.$emit("goToStep", step);
        },
        scrollUp() {
            this.$el.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        },
        scrollDown() {
            this.$el.scrollTo({
                top: this.$el.scrollHeight - this.$el.clientHeight,
                behavior: "smooth"
            });
        },
        sidenavScroll() {
            let topPosition = this.$el.scrollTop;
            let bottomPosition = this.$el.scrollHeight - (topPosition + this.$el.clientHeight);

            this.moveUpVisible = topPosition > 60;
            this.moveDownVisible = bottomPosition > 60;
        }
    },
    computed: {
        isSidebarScrollable() {
            return this.$el.scrollHeight !== this.$el.clientHeight;
        }
    },
    mounted() {
        if (this.isSidebarScrollable) {
            this.moveUpVisible = false;
            this.moveDownVisible = true;
        }

    },
    watch: {
        // reload sidenav scroll
        activeIndex: function (activeIndex) {
            if (this.isSidebarScrollable) {
                let offset = (parseInt(activeIndex) + 2) * 54,
                    sidenavContentHeight = this.$el.clientHeight - 100;

                this.$el.scrollTo({
                    top: offset - sidenavContentHeight,
                    behavior: "smooth"
                });
            }
        }
    }
}
</script>
